import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface JsonVersionDTO {
  version: number;
}

export class JsonVersion {
  readonly isJsonVersionJsonVersion: boolean = true;

  readonly version: number;

  static readonly constraints = {
    "version": {
      "minValue": 1,
    }
  }

  constructor(
  version: number
  ) {
    JsonVersion.validateVersion(version);
    this.version = version;
  }

  static fromDTO(dto: JsonVersionDTO): JsonVersion {
    const version = getInt32(dto, "version", InvalidJsonVersionVersionError);
    return new JsonVersion(
      version
    );
  }

  toDTO(): JsonVersionDTO {
    const dto: JsonVersionDTO = {
        version: this.version
    };
    return dto;
  }
  private static validateVersion = (version: number): void => {
    if(version < 1) {
      throw new InvalidJsonVersionVersionMinValueError(
        1,
        `Attribute version has value ${version}. Min value is 1.`
      );
    }
  }
  
}

JsonVersion.prototype.toString = function toString(): string {
  return `JsonVersion(version='${this.version}')`;
};

export class InvalidJsonVersionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidJsonVersionError";
  }
}
export class InvalidJsonVersionVersionError extends InvalidJsonVersionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidJsonVersionVersionError";
  }
}

export class InvalidJsonVersionVersionMinValueError extends InvalidJsonVersionVersionError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidJsonVersionVersionMinValueError";
  }
}
